import React from "react";

export const SuccessAlertContext = React.createContext<(message: string) => void>(() => {});

export function useSuccessAlert() {
	const setSuccessMessage = React.useContext(SuccessAlertContext);
	return setSuccessMessage;
}
